import { globalJson } from "global/global_json";
import newyork from "images/newyork.png";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

const DriveLuxury = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="bg-black text-white py-16 px-6 flex flex-col md:flex-row items-center justify-between">
      <div className=" flex justify-center items-center">
        <div className="relative rounded-lg overflow-hidden shadow-lg max-w-xl">
          <img src={newyork} className="w-full object-cover" />
        </div>
      </div>
      <div className="md:w-1/2 text-left mt-10 md:mt-0 md:pl-12 space-y-4">
        <span className="bg-gradient-to-r from-[#18CC3D] to-[#00A8F3] bg-clip-text text-transparent text-lg font-medium">
          About Us
        </span>
        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
          Choose Your Ride – Luxury, Electric, and Economy Cars
        </h2>
        <p className="text-gray-300 text-base leading-relaxed">
          {globalJson.about_us_para}
        </p>
        {location.pathname !== "/about" && (
          <ButtonPrimary
            className="bg-primary-500 mt-5"
            onClick={() => {
              navigate("/about");
            }}
          >
            Read More
          </ButtonPrimary>
        )}
      </div>
    </div>
  );
};

export default DriveLuxury;
